import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import lottoLogo from '../assets/images/lottologo.jpg';
import goldenLotteryLogo from '../assets/images/golden.webp';
import template4Logo from '../assets/images/template4logo.jpg';
import { toCurrency } from '../utils/helper';

dayjs.extend(customParseFormat);

export default function TicketTemplate6({
  transaction,
  displayName,
  userName,
  userTicketMeta,
}) {
  const bets = useMemo(() => {
    const sortedBets = [...transaction.bets].sort((a, b) => {
      if (a.drawTime !== b.drawTime)
        return a.drawTime.localeCompare(b.drawTime);
      const gameA = a.GameSetting?.name || a.gameName || '';
      const gameB = b.GameSetting?.name || b.gameName || '';
      return gameA.localeCompare(gameB);
    });
    return sortedBets;
  }, [transaction]);

  const drawId = dayjs(transaction.drawDate)
    .diff(dayjs('2025-04-12'), 'day')
    .toString()
    .padStart(4, '0');

  return (
    <div className='grid max-h-0 overflow-hidden'>
      <div
        id='print-ticket'
        className='w-[230px] text-[13.5px] flex flex-col gap-4 bg-white font-bitMatrix antialiased'
      >
        <div className='flex flex-col'>
          <div className='flex flex-col justify-between'>
            <div className='leading-tight'>
              <div className='flex justify-center items-center gap-1 w-full mb-1'>
                <img src={lottoLogo} className='h-[60px]' />
                <img src={goldenLotteryLogo} className='h-[45px]' />
                <img src={template4Logo} className=' h-[60px]' />
              </div>
              <span className='w-full h-[1px] border-t border-dashed border-black my-2 block'></span>
              <div>GOLDEN 74 AMUSEMENT MGMT CORP.</div>
              <span className='w-full h-[1px] border-t border-dashed border-black my-2 block'></span>

              <div className='flex flex-col text-left'>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Ref No:</span>
                  {drawId +
                    '-' +
                    dayjs(transaction.bets[0].createdAt).format('YYMMDD') +
                    new Date().getTime().toString().slice(-6)}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Draw:</span>
                  {dayjs(transaction.bets[0].createdAt).format('MMM DD, YYYY ')}
                  {dayjs(transaction.drawTime, 'HH:mm').format('hA')}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Sec. Key:</span>
                  {userTicketMeta?.secNo || '306752'}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Agent:</span>
                  {displayName}
                </div>
                <div className='flex'>
                  <span className='w-[65px] text-right mr-1'>Agent No:</span>
                  {userTicketMeta?.agentNo || `LA-IPL-${transaction.userId}`}
                </div>
                <div className='flex'>
                  <span>
                    Municipality:{' '}
                    {userTicketMeta?.municipality || "IPIL-Veteran's Village"}
                  </span>
                </div>
                <span className='w-full h-[1px] border-t border-dashed border-black block mt-2'></span>
                <span className='w-full h-[1px] border-t border-dashed border-black mt-0.5 mb-1 block'></span>
                <div className='grid grid-cols-4'>
                  <div>Game</div>
                  <div>Nos</div>
                  <div>Amt Type</div>
                  <div className='text-right'>Win</div>
                </div>
                <span className='w-full h-[1px] border-t border-dashed border-black block mt-1'></span>
                <span className='w-full h-[1px] border-t border-dashed border-black mt-0.5 mb-2 block'></span>
                {bets.map((bet, index) => (
                  <div key={index} className='grid grid-cols-4 font-bold'>
                    <div className='text-left'>3D</div>
                    <div>{bet.combination}</div>
                    <div>
                      {bet.amount} {bet.bettingOption === 'ramble' ? 'R' : 'T'}
                    </div>
                    <div className='text-right'>
                      {toCurrency(bet.winAmount)}
                    </div>
                  </div>
                ))}
                <span className='w-full h-[1px] border-t border-dashed border-black my-1 block'></span>
                <span className='mt-1 font-bold'>
                  Total : P {transaction.totalAmount} ({bets.length} bets)
                </span>
                <span className='w-full h-[1px] border-t border-dashed border-black block mt-1'></span>
                <span className='w-full h-[1px] border-t border-dashed border-black mt-0.5 mb-1 block'></span>
              </div>
            </div>
            {/* QR Code */}
            <span className='text-left'>
              Printed :{' '}
              {dayjs(transaction.bets[0].createdAt).format(
                'MMM DD, YYYY HH:mm:ss'
              )}
            </span>
            <span className='text-center font-bold'>NO TICKET, NO CLAIM</span>
            <span className='text-left'>
              Palihog ko tago sa ticket og ampingan para gamiton pag claim
            </span>
            <span className='text-left'>TICKET IS VALID FOR ONE (1) YEAR</span>
            <div className='flex justify-center my-2'>
              <QRCodeSVG value={transaction.id} width={80} height={80} />
            </div>
          </div>
        </div>
        <div className='h-4'></div>
      </div>
    </div>
  );
}
